export { MainTitle } from "./main-title";
